/**
 * App Component - Client-side Router
 *
 * React Router + SPA após hydration
 */

import { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import QuestionPage from './components/QuestionPage'
import { FreemiumCounter } from './components/FreemiumCounter'
import LandingPage from './components/LandingPage'
import FeedPage from './components/FeedPage'
import type { QuestionMeta } from '@/shared/types/question'

interface FeedItem {
  type: string
  content: any
}

interface AppProps {
  initialData?: QuestionMeta | { feed: FeedItem[] }
}

export default function App({ initialData }: AppProps) {
  const [data, setData] = useState<QuestionMeta | { feed: FeedItem[] } | undefined>(initialData)

  useEffect(() => {
    console.log('[App] Hydrated with data:', data)
  }, [data])

  return (
    <BrowserRouter>
      <Routes>
        {/* Homepage - sem wrapper para LandingPage ter controle total */}
        <Route path="/" element={<LandingPage />} />

        {/* Feed - rota SSR */}
        <Route
          path="/feed"
          element={
            <FeedPage
              initialItems={data && 'feed' in data ? data.feed : []}
            />
          }
        />

        {/* Outras rotas - com wrapper e FreemiumCounter */}
        <Route
          path="/questoes/:categoria/:subcategoria/:questionPath"
          element={
            <div className="min-h-screen bg-gray-900 text-white">
              <div className="container mx-auto p-4">
                <FreemiumCounter />
              </div>
              <QuestionPage initialQuestion={data && !('feed' in data) ? data : undefined} />
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}
